import { Component, OnInit, NgZone, ViewChild } from "@angular/core";
import { GeneralService } from "../services/general.service";
import { MatDialogConfig, MatDialog } from "@angular/material/dialog";
import { RechercheModalComponent } from "../recherche-modal/recherche-modal.component";
import { Router } from "@angular/router";
import { ListeComponent } from "../liste/liste.component";
declare var $: any;
@Component({
  selector: "app-banniere",
  templateUrl: "./banniere.component.html",
  styleUrls: ["./banniere.component.scss"],
})
export class BanniereComponent implements OnInit {
  constructor(
    private router: Router,
    private dialog: MatDialog,
    private ngZone: NgZone,
    public generalService: GeneralService
  ) {}
  useDataBaseToSaveImage = this.generalService.useDataBaseToSaveImage;
  base_url = this.generalService.base_url;
  enregistrementTerminer: boolean = true;
  selectedImageDeatail: number;
  nbrImage: number = 0;
  initDoc: any;
  initImgArt;
  imageToUpload = { base64: null, name: "", code: "" };
  listeImages = [];
  buttonDisabled: boolean = false;
  listBtn: Array<any> = [
    {
      name: "ajouter",
      class: "colorGreen",
      text: "Ajouter article",
      disabled: false,
      icon: "add",
    },
    {
      name: "supprimer",
      class: "colorRed",
      text: "Supprimer article",
      disabled: false,
      icon: "delete",
    },
  ];
  columns = {
    TableRD: [
      // { "TableRE_Code": "", "TableRD_Champs": "ecImgArt_Id", "Lg_Code": "", "TableRD_Des": "Code", "TableRD_Largeur": 70, "TableRD_ReadOnly": true, "TableRD_Format": null, "TableRD_Alligement": 0, "TableRD_Ordre": 1, "TableRD_Type": 0, "TableRD_Param1": null, "TableRD_Param2": null, "TableRD_ValDef": null, "TableRD_Tri": true, "TableRD_Valid": null, "TableRD_ValidType": 0, "TableRD_ExpressionH": null, "TableRD_ExpressionR": null, "User_Id": "*", "User_Groupe": null },
      {
        TableRE_Code: "",
        TableRD_Champs: "Art_Code",
        Lg_Code: "",
        TableRD_Des: "Code article",
        TableRD_Largeur: 70,
        TableRD_ReadOnly: true,
        TableRD_Format: null,
        TableRD_Alligement: 0,
        TableRD_Ordre: 2,
        TableRD_Type: 0,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: "*",
        User_Groupe: null,
      },
      {
        TableRE_Code: "",
        TableRD_Champs: "Art_Des",
        Lg_Code: "",
        TableRD_Des: "Article",
        TableRD_Largeur: 200,
        TableRD_ReadOnly: true,
        TableRD_Format: null,
        TableRD_Alligement: 0,
        TableRD_Ordre: 3,
        TableRD_Type: 0,
        TableRD_Param1: null,
        TableRD_Param2: "number",
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: "*",
        User_Groupe: null,
      },
    ],
  };
  // listeAllArticleImage = [];
  image_1_234_450Charger: boolean = false;
  image_2_234_450Charger: boolean = false;
  image_2_Banner2_1_Charger: boolean = false;
  image_2_Banner2_2_Charger: boolean = false;
  img_1_234_450: any = {
    File_Content: "",
    File_Id: "",
    File_Lien: "",
    Art_Des: "",
  };
  img_2_234_450: any = {
    File_Content: "",
    File_Id: "",
    File_Lien: "",
    Art_Des: "",
  };
  Banner1: any = {
    File_Content: "",
    File_Id: "",
    File_Lien: "",
    Art_Des: "",
  };
  Banner2: any = {
    File_Content: "",
    File_Id: "",
    File_Lien: "",
    Art_Des: "",
  };
  @ViewChild("listeComponen") listeComponen: ListeComponent;
  dsLanguage;
  ngOnInit() {
    if (this.generalService.userConnecter == "") {
      this.router.navigate([""]);
    } else {
      // this.getAllArticleImage()
      this.afficherArticleImage();
      this.getInitDoc();
      //get from server ds ecImgArt
      // this.getInitImgArt();
      this.getImageBanniere();
      this.getImageBanniereImageFixe();
    }
  }
  getImageBanniereImageFixe() {
    this.generalService
      .rechercheTable(
        this.generalService.urlListeFilesR2 + "banniere1" + "," + "ecImage"
      )
      .subscribe((img) => {
        this.image_1_234_450Charger = true;
        if (img.length > 0) {
          this.img_1_234_450.File_Id = img[0].File_Id;
          this.generalService
            .rechercheTable(
              this.generalService.urlFiles + "&val=" + img[0].File_Id
            )
            .subscribe((file) => {
              this.img_1_234_450.File_Content = file.Files[0].File_Content;
              this.img_1_234_450.File_Lien = file.Files[0].File_Lien;
            });
        }
      });
    this.generalService
      .rechercheTable(
        this.generalService.urlListeFilesR2 + "banniere2" + "," + "ecImage"
      )
      .subscribe((img) => {
        this.image_2_234_450Charger = true;
        if (img.length > 0) {
          this.img_2_234_450.File_Id = img[0].File_Id;
          this.generalService
            .rechercheTable(
              this.generalService.urlFiles + "&val=" + img[0].File_Id
            )
            .subscribe((file) => {
              this.img_2_234_450.File_Content = file.Files[0].File_Content;
              this.img_2_234_450.File_Lien = file.Files[0].File_Lien;
            });
        }
      });
    this.generalService
      .rechercheTable(
        this.generalService.urlListeFilesR2 + "banniere3" + "," + "ecImage"
      )
      .subscribe((img) => {
        this.image_2_Banner2_1_Charger = true;
        if (img.length > 0) {
          this.Banner1.File_Id = img[0].File_Id;
          this.generalService
            .rechercheTable(
              this.generalService.urlFiles + "&val=" + img[0].File_Id
            )
            .subscribe((file) => {
              this.Banner1.File_Content = file.Files[0].File_Content;
              this.Banner1.File_Lien = file.Files[0].File_Lien;
            });
        }
      });
    this.generalService
      .rechercheTable(
        this.generalService.urlListeFilesR2 + "banniere4" + "," + "ecImage"
      )
      .subscribe((img) => {
        this.image_2_Banner2_2_Charger = true;
        if (img.length > 0) {
          this.Banner2.File_Id = img[0].File_Id;
          this.generalService
            .rechercheTable(
              this.generalService.urlFiles + "&val=" + img[0].File_Id
            )
            .subscribe((file) => {
              this.Banner2.File_Content = file.Files[0].File_Content;
              this.Banner2.File_Lien = file.Files[0].File_Lien;
            });
        }
      });
  }
  updateLienBanner2() {
    if (
      this.Banner2.File_Id != "" &&
      this.Banner2.File_Id &&
      this.Banner2.File_Lien != this.lastLinkWhenFocus
    ) {
      this.generalService
        .rechercheTable(
          this.generalService.urlFiles + "&val=" + this.Banner2.File_Id
        )
        .subscribe((file) => {
          file.Files[0].File_Lien = this.Banner2.File_Lien;
          this.generalService.enregisterTable(file).subscribe(
            (data) => {
              this.generalService.dialogSuccess(" enregisté", true);
              this.enregistrementTerminer = true;
              this.getImageBanniere();
            },
            (err) => {
              this.enregistrementTerminer = true;
              this.generalService.dialogSuccess(" non enregisté", false);
            }
          );
        });
    }
  }
  lastLinkWhenFocus = "";
  onFocusInput() {
    this.lastLinkWhenFocus = this.Banner2.File_Lien;
  }
  // getAllArticleImage() {
  //   this.generalService.rechercheTable("recherche/tbdata?tablere=ecImgArt").subscribe(data => {
  //     this.listeAllArticleImage = data;
  //     this.afficherArticleImage();
  //   });
  // }
  // getInitImgArt() {
  //   this.generalService.rechercheTable("ds/formdata?code=ecImgArt").subscribe(data => {
  //     console.log(data);

  //     this.initImgArt = data;
  //   });
  // }
  clickBtnHeat(event) {
    switch (event.name) {
      case "supprimer": {
        this.supprimerArticleImage();
        break;
      }

      case "ajouter": {
        this.ajouterArticle();
        break;
      }
    }
  }
  getInitDoc() {
    this.generalService
      .rechercheTable(this.generalService.urlAvtDoc)
      .subscribe((doc) => {
        this.initDoc = doc;
      });
  }
  getImageBanniere() {
    this.listeImages = [];
    this.generalService
      .rechercheTable(
        this.generalService.urlListeFilesR2 + "banniere" + "," + "ecImage"
      )
      .subscribe((img) => {
        this.listeImages = img;
        this.getLangueBanniere();
        this.nbrImage = this.listeImages.length;
        this.getImageContentBanniere();
      });
  }
  enregistrerTextImage() {
    this.enregistrementTerminer = false;
    this.buttonDisabled = true;
    this.generalService
      .rechercheTable(
        "ds/formdata?code=avtFiles&val=" + this.selectedImageDeatail
      )
      .subscribe(
        (data) => {
          var img = this.listeImages.find((img) => {
            return img.File_Id == this.selectedImageDeatail;
          });
          data.Files[0].File_Text = img.File_Text;
          this.generalService.enregisterTable(data).subscribe(
            (d) => {
              this.buttonDisabled = false;
              this.enregistrementTerminer = true;
              this.generalService.dialogSuccess("Enregistrer", true);
            },
            () => {
              this.buttonDisabled = false;
              this.enregistrementTerminer = true;
              this.generalService.dialogSuccess("Non enregistrer", false);
            }
          );
        },
        () => {
          this.buttonDisabled = false;
          this.enregistrementTerminer = true;
          this.generalService.dialogSuccess("Non enregistrer", false);
        }
      );
    this.saveLanguage();
  }
  saveLanguage() {
    // try {
    //   if (this.selectedImageDeatail != null) {
    //     var img = this.listeImages.find(art => { return art.File_Id == this.selectedImageDeatail.toString() })
    //     for (let i = 0; i < 2; i++) {
    //       this.generalService.rechercheTable("recherche/tbdata?tablere=Lg&param=" + i + "," + this.selectedImageDeatail).subscribe(data => {
    //         var text = img.File_Text;
    //         if (i == 1)
    //           text = (img.textAnglais != undefined ? img.textAnglais : "");
    //         if (data.length > 0) {
    //           this.generalService.modifierLanguage(data[0].Lg_Id, text)
    //         }
    //         else {
    //           this.generalService.enregistrerLanguage(img.File_Id, i, text)
    //         }
    //       })
    //     }
    //   }
    // }
    // catch
    // {
    // }
  }
  getLangueBanniere() {
    // try {
    //   for (let i = 0; i < this.listeImages.length; i++) {
    //     this.generalService.rechercheTable("recherche/tbdata?tablere=Lg&param=1," + this.listeImages[i].File_Id).subscribe(data => {
    //       if (data.length > 0)
    //         this.listeImages[i].textAnglais = data[0].Lg_Libelle
    //     });
    //   }
    // }
    // catch
    // {
    // }
  }
  getImageContentBanniere() {
    // for (let i = 0; i < this.nbrImage; i++) {
    //   this.generalService
    //     .rechercheTable(
    //       this.generalService.urlFiles + "&val=" + this.listeImages[i].File_Id
    //     )
    //     .subscribe((file) => {
    //       this.listeImages[i].File_Content = file.Files[0].File_Content;
    //     });
    // }
  }
  importer(id) {
    document.getElementById("input_" + id).click();
  }
  file;
  onChangeImagefile(fileInput, mode) {
    var src;
    this.file = fileInput.target.files[0];
    console.log("aaaaaaaa", this.file);

    var current_file = fileInput.target.files[0];
    var reader = new FileReader();
    if (current_file.type.indexOf("image") == 0) {
      this.enregistrementTerminer = false;
      reader.onload = (e) => {
        var image = new Image();
        image.src = reader.result.toString();
        image.onload = (ev) => {
          var code;
          code = this.nbrImage + 1 + "_666_450";
          this.imageToUpload.base64 = this.generalService.redimentionnerImage(
            image,
            1000,
            370,
            80
          );
          console.log(this.imageToUpload);

          this.imageToUpload.code = code;
          this.imageToUpload.name = fileInput.target.files[0].name;

          if (mode == "ajouterBannier")
            this.ajouterListeDetailImage(current_file);
          if (mode == "modifierBannier") {
            if (this.selectedImageDeatail != undefined) {
              src = reader.result.toString();
              var imagee = document.getElementById(
                this.selectedImageDeatail.toString()
              );
              imagee.setAttribute("src", src);
            }
            this.modifierDetailImage();
          }
          if (mode == "enregistrerImageFixe1") {
            this.imageToUpload.code = "1_234_450";
            this.enregistrerImageFixe(
              reader,
              this.img_1_234_450,
              this.imageToUpload,
              "234 / 450",
              "1_234_450",
              this.image_1_234_450Charger,
              "banniere1",
              current_file
            );
          }
          if (mode == "enregistrerImageFixe2") {
            this.imageToUpload.code = "2_234_450";
            this.enregistrerImageFixe(
              reader,
              this.img_2_234_450,
              this.imageToUpload,
              "234 / 450",
              "2_234_450",
              this.image_2_234_450Charger,
              "banniere2",
              current_file
            );
          }
          if (mode == "enregistrerBanner2.1") {
            this.imageToUpload.code = "2_234_450";
            this.enregistrerImageFixe(
              reader,
              this.Banner1,
              this.imageToUpload,
              "Petite banniére 1 ",
              "banniere2.1",
              this.image_2_Banner2_1_Charger,
              "banniere3",
              current_file
            );
          }
          if (mode == "enregistrerBanner2.2") {
            this.imageToUpload.code = "2_234_450";
            this.enregistrerImageFixe(
              reader,
              this.Banner2,
              this.imageToUpload,
              "Petite banniére 2",
              "banniere2.2",
              this.image_2_Banner2_2_Charger,
              "banniere4",
              current_file
            );
          }
        };
      };
      reader.readAsDataURL(current_file);
    } else
      this.generalService.dialogSuccess(
        "Veuillez sélectionner une image",
        false
      );
  }
  urlCategorie = "";
  enregistrerImageFixe(
    reader,
    img_234_450,
    imageToUpload,
    text,
    id,
    image_234_450Charger,
    banniere,
    base64
  ) {
    if (image_234_450Charger) {
      if (img_234_450.File_Id != "") {
        var src = reader.result.toString();
        var imagee = document.getElementById(id);
        imagee.setAttribute("src", src);
        this.modifierImage(
          img_234_450.File_Id,
          base64,
          imageToUpload,
          "Image " + text,
          ""
        );
      } else {
        if (this.initDoc != undefined) {
          this.addFiles(
            this.initDoc,
            imageToUpload.base64,
            imageToUpload,
            imageToUpload.code,
            "ecImage",
            "",
            "crerFichier",
            banniere,
            "",
            "234 * 450"
          );
        } else
          this.generalService.dialogSuccess(
            "veuillez patientez un moment pendant la chargement totale du page ",
            false
          );
      }
    } else
      this.generalService.dialogSuccess(
        "veuillez patientez un moment pendant la chargement totale du page ",
        false
      );
  }
  ajouterListeDetailImage(file) {
    if (this.initDoc != undefined) {
      if ($("#input_666_450").val() != "") {
        $("#" + this.selectedImageDeatail).attr("style", "");
        this.selectedImageDeatail = null;
        this.addFiles(
          this.initDoc,
          this.imageToUpload.base64,
          file,
          this.imageToUpload.code,
          "ecImage",
          "",
          "crerFichier",
          "banniere",
          "",
          "666 * 450"
        );
      } else {
        this.generalService.dialogSuccess(
          "Une erreur est survenue veuillez réessayer de nouveau",
          false
        );
      }
    } else
      this.generalService.dialogSuccess(
        "veuillez patientez un moment pendant la chargement totale du page ",
        false
      );
  }
  addFiles(
    initDoc,
    File_Content,
    File,
    File_Key,
    File_Type,
    File_Parent,
    clickMode,
    File_Groupe,
    File_Lien,
    taille
  ) {
    var File_Text = File.name;
    //
    var doc = this.generalService.clone(initDoc);
    if (clickMode != "renommer") {
      doc.files[0].File_Parent = File_Parent;
      doc.files[0].File_Content = File_Content;
      doc.files[0].File_Text = File_Groupe;
      doc.files[0].File_Key = File_Groupe + "_" + File_Key;
      doc.files[0].File_Type = File_Type;
      doc.files[0].File_Groupe = File_Groupe;
      doc.files[0].File_Lien = File_Lien;
      doc.files[0].File_Class = 1;
      if (this.generalService.useDataBaseToSaveImage == 0) {
        // File_Content=this.extractContentBetweenQuotes(File_Content.toString())
        // var blob = dataURLToBlob(File);
        console.log(1111111);
        console.log(this.file);

        this.generalService.uploadFile2(this.file, File_Text).subscribe(
          (data1) => {
            doc.files[0].File_Content = data1["fileName"];
            this.generalService.enregisterTable(doc).subscribe(
              (data) => {
                this.generalService.dialogSuccess(
                  "image " + taille + " enregisté",
                  true
                );
                this.enregistrementTerminer = true;
                this.getImageBanniere();
              },
              (err) => {
                this.enregistrementTerminer = true;
                this.generalService.dialogSuccess(
                  "image " + taille + " non enregisté",
                  false
                );
              }
            );
          },
          (err) => {
            this.enregistrementTerminer = true;
            this.generalService.dialogSuccess(" non enregisté", false);
          }
        );
      } else {
        this.generalService.enregisterTable(doc).subscribe(
          (data) => {
            this.generalService.dialogSuccess(
              "iamge " + taille + " enregisté",
              true
            );
            this.enregistrementTerminer = true;
            this.getImageBanniere();
          },
          (err) => {
            this.generalService.dialogSuccess(
              "image " + taille + " non enregisté",
              false
            );
          }
        );
      }
    }
  }
  modifierDetailImage() {
    if (this.selectedImageDeatail != null) {
      var img = this.listeImages.find((img) => {
        return img.File_Id == this.selectedImageDeatail;
      });
      this.enregistrementTerminer = false;
      console.log(this.imageToUpload);
      this.modifierImage(
        img.File_Id,
        this.imageToUpload.base64,
        this.file,
        "image 666 * 450 ",
        ""
      );
    } else {
      this.generalService.dialogSuccess(
        "Veuillez sélectionner une image",
        false
      );
    }
  }
  modifierImage(File_Id, base64, file, text, lien) {
    var name = file.name;
    if (this.generalService.useDataBaseToSaveImage == 0) {
      // File_Content=this.extractContentBetweenQuotes(File_Content.toString())
      // var blob = dataURLToBlob(File);

      console.log("bbbb", file);

      this.generalService.uploadFile2(base64, name).subscribe(
        (data1) => {
          this.generalService
            .rechercheTable(
              this.generalService.urlFiles + "&val=" + File_Id.toString()
            )
            .subscribe((data) => {
              data.Files[0].File_Content = data1["fileName"];
              if (name != "") data.Files[0].File_Text = name;
              if (lien != "") data.Files[0].File_Lien = lien;
              console.log(data);

              this.generalService.enregisterTable(data).subscribe(
                (data2) => {
                  console.log(data2);

                  this.enregistrementTerminer = true;
                  this.generalService.dialogSuccess(text + " enregisté", true);
                  this.enregistrementTerminer = true;
                  this.getImageBanniere();
                },
                (err) => {
                  console.log(err);
                  this.generalService.dialogSuccess(
                    text + " non enregisté",
                    false
                  );
                }
              );
            });
        },
        (err) => {
          this.generalService.dialogSuccess(text + " non enregisté", false);
        }
      );
    } else {
      this.generalService
        .rechercheTable(
          this.generalService.urlFiles + "&val=" + File_Id.toString()
        )
        .subscribe((data) => {
          if (base64 != "") data.Files[0].File_Content = base64;
          if (name != "") data.Files[0].File_Text = name;
          if (lien != "") data.Files[0].File_Lien = lien;
          this.generalService.enregisterTable(data).subscribe(
            (data) => {
              this.enregistrementTerminer = true;
              this.generalService.dialogSuccess(text + " enregisté", true);
            },
            (e) => {
              this.generalService.dialogSuccess(text + " non enregisté", false);
            }
          );
        });
    }
  }
  selectImageDeatail(id: number) {
    this.selectedImageDeatail = id;
    for (var i = 0; i < this.listeImages.length; i++) {
      $("#" + this.listeImages[i].File_Id).attr("style", "");
    }
    $("#" + id).attr("style", "border-color: blue;   border-style: solid;");
    this.afficherArticleImage();
  }
  afficherArticleImage() {
    if (this.generalService.isNotEmpty(this.selectedImageDeatail)) {
      this.generalService
        .rechercheTable(
          this.generalService.urlFiles +
            "&val=" +
            this.selectedImageDeatail.toString()
        )
        .subscribe((data) => {
          if (data.Files[0].File_Lien) {
            this.listeComponen.setDataSource([]);
            this.generalService
              .rechercheTable(
                this.generalService.urlArticle +
                  "&val=" +
                  data.Files[0].File_Lien
              )
              .subscribe((art) => {
                // console.log(art);

                var articles = [art.Art[0]];
                // var articles = [art.Art[0].Art_Code,art.Art[0].Art_Des]$
                console.log(articles);

                this.listeComponen.setDataSource(articles);
              });
          } else this.listeComponen.setDataSource([]);
        });
    }
  }
  enregistrerInitImgArt(Art_Code, File_Id, article) {
    this.generalService
      .rechercheTable(
        this.generalService.urlFiles + "&val=" + File_Id.toString()
      )
      .subscribe((data) => {
        console.log(data);
        data.Files[0].File_Lien = Art_Code;
        this.generalService.enregisterTable(data).subscribe(
          (resp) => {
            this.enregistrementTerminer = true;
            this.generalService.dialogSuccess("Enregistrer", true);
            this.generalService.dialogSuccess("Enregistrer", true);
          },
          () => {
            this.enregistrementTerminer = true;
            this.generalService.dialogSuccess("Non enregistrer", false);
          }
        );
      });
    // this.enregistrementTerminer = false;
    // console.log(this.initImgArt);

    // this.initImgArt.ecImgArt[0].Art_Code = Art_Code;
    // this.initImgArt.ecImgArt[0].File_Id = File_Id;
    // this.generalService.enregisterTable(this.initImgArt).subscribe(data => {
    //   this.enregistrementTerminer = true;
    //   this.generalService.dialogSuccess("Enregistrer", true);
    //   this.initImgArt = null;
    //   this.getInitImgArt();
    //   this.getAllArticleImage();
    // }, () => {
    //   this.enregistrementTerminer = true;
    //   this.generalService.dialogSuccess("Non enregistrer", false)
    // })
  }
  ajouterArticle1() {
    if (this.selectedImageDeatail != null) {
      const dialogConfig = new MatDialogConfig();
      dialogConfig.autoFocus = true;
      var dialogRef = this.dialog.open(RechercheModalComponent, dialogConfig);
      dialogRef.afterClosed().subscribe((article) => {
        if (article != undefined && article != null && article != "") {
          var img = this.listeImages.find((img) => {
            return img.File_Id == this.selectedImageDeatail;
          });
          this.enregistrementTerminer = false;
          img.File_Lien = article.Art_Code;
          this.modifierImage(img.File_Id, "", "", "image ", article.Art_Code);
        }
      });
    } else {
      this.generalService.dialogSuccess(
        "Veuillez sélectionner une image",
        false
      );
    }
  }
  ajouterArticle() {
    if (this.generalService.isNotEmpty(this.selectedImageDeatail)) {
      // if (this.generalService.isNotEmpty(this.initImgArt)) {
      const dialogConfig = new MatDialogConfig();
      dialogConfig.autoFocus = true;
      var dialogRef = this.dialog.open(RechercheModalComponent, dialogConfig);
      dialogRef.afterClosed().subscribe((article) => {
        if (article != undefined && article != null && article != "") {
          var img = this.listeImages.find((img) => {
            return img.File_Id == this.selectedImageDeatail;
          });
          //this.modifierImage(img.File_Id,"","","",article.Art_Code);
          this.enregistrerInitImgArt(article.Art_Code, img.File_Id, article);
        }
      });
      // }
      // else
      //   this.generalService.dialogSuccess("Veuillez patienter pendant le chargement total des données", false)
    } else {
      this.generalService.dialogSuccess(
        "Veuillez sélectionner une image",
        false
      );
    }
  }
  supprimer() {
    if (this.selectedImageDeatail != null) {
      var deleteFn = this.generalService.supprimer(
        this.selectedImageDeatail,
        "avtFiles"
      );
      if (deleteFn != null) {
        this.enregistrementTerminer = false;
        this.buttonDisabled = true;
        deleteFn.subscribe(
          (data) => {
            this.listeImages = this.listeImages.filter((img) => {
              return img.File_Id != this.selectedImageDeatail;
            });
            this.generalService.dialogSuccess("Elément supprimer", true);
            this.enregistrementTerminer = true;
            this.buttonDisabled = false;
          },
          (error) => {
            this.generalService.dialogSuccess("Elément non supprimé", false);
            this.enregistrementTerminer = true;
            this.buttonDisabled = false;
          }
        );
      }
    }
  }
  supprimerArticleImage() {
    // if (this.generalService.isNotEmpty(this.listeComponen.row)) {
    // var deleteFn = this.generalService.supprimer(this.listeComponen.row.ecImgArt_Id, "ecImgArt");
    //     if (deleteFn != null) {
    //       this.enregistrementTerminer = false;
    //       this.buttonDisabled = true;
    //       deleteFn.subscribe(data => {
    //         // this.listeAllArticleImage = this.listeAllArticleImage.filter(art => { return art.ecImgArt_Id != this.listeComponen.row.ecImgArt_Id });
    //         this.afficherArticleImage();
    //         this.generalService.dialogSuccess("Elément supprimer", true);
    //         this.enregistrementTerminer = true;
    //         this.buttonDisabled = false;
    //       },
    //         error => {
    //           this.generalService.dialogSuccess("Elément non supprimé", false);
    //           this.enregistrementTerminer = true;
    //           this.buttonDisabled = false;
    //         });
    //     }
    //   }
    //   else
    //     this.generalService.dialogSuccess("Veuillez sélectionner un article à supprimer", false)
    this.generalService
      .rechercheTable(
        this.generalService.urlFiles +
          "&val=" +
          this.selectedImageDeatail.toString()
      )
      .subscribe((data) => {
        data.Files[0].File_Lien = null;
        this.generalService.enregisterTable(data).subscribe(
          (resp) => {
            this.enregistrementTerminer = true;
            this.listeComponen.setDataSource([]);
            this.generalService.dialogSuccess("Enregistrer", true);
            this.generalService.dialogSuccess("Enregistrer", true);
          },
          () => {
            this.enregistrementTerminer = true;
            this.generalService.dialogSuccess("Non enregistrer", false);
          }
        );
      });
  }
}
